import {useIndividualizationContext} from "../../../../contexts/individualizationContext";
import React from "react";
import Heading from "../../../../components/Heading";
import {useTranslation} from "react-i18next";
import cx from "classnames";
import styles from "./ErrorBar.module.css";

const ErrorBar: React.FC = () => {
    const {errors} = useIndividualizationContext()
    const {t} = useTranslation(['global'])

    return errors.length > 0 ? (<div className={cx(styles['container'])}>
        <Heading level={4}>{t("danger")}</Heading>
        <ul>
            {errors.map(e => {
                return <li>{e}</li>
            })}
        </ul>
    </div>) : null
}

export default ErrorBar
